<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div v-if="inputGroupBy == 'monthly'" class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-month-picker v-model="inputFrom" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                            </base-input>
                        </div>

                        <div class="col-md-4">
                            <base-input alternative="" label="To"><br>
                                <a-month-picker v-model="inputTo" placeholder="Select month" style="width:100%" :format="monthFormat"/>
                            </base-input>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row" v-if="site_type == 'ho'">
                        <div class="col-md-4">
                            <base-input label="Location">
                                <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="sortChange">>
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>

                    <div class="row" v-if="inputGroupBy == '' && inputSortBy != 'parent_child'">
                        <div class="col-md-4">
                            <base-input label="Filter By" >
                                <select class="form-control" size="large" v-model="inputFilterBy" @click.prevent="sortChange">>
                                    <option v-for="filter in filterOptions" v-bind:value="filter.key" v-bind:key="filter.key">
                                        {{ filter.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input type="number" min="0" v-if="inputSortBy == 'total_amount' || inputSortBy == 'qty'" placeholder="" label="Show Top" v-model="inputShowTop" />
                            <base-input type="number" min="0" v-else placeholder="" label="Show Top" v-model="inputShowTop" disabled/>
                        </div>
                    </div>

                    <base-checkbox class="mb-3" v-model="isShowDetail" :disabled="inputGroupBy == ''">
                        Show Details
                    </base-checkbox>
                    <base-checkbox class="mb-3" v-model="isSeparateSite">
                        Separate per site
                    </base-checkbox>

                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{toggleLabel}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.toString().replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        components: {
            AdvanceFilter,VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: '',
                groupOptions: [
                    {key: '', value: 'No Grouping'},
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'supplier_type_id', value: 'Supplier Type, Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'},
                    {key: 'customer_id', value: 'Customer'},
                    {key: 'customer_type_id', value: 'Customer Type'},
                    {key: 'daily', value: 'Daily Sales'},
                    {key: 'monthly', value: 'Monthly Sales'},
                    {key: 'salesman_id', value: 'Salesman'},
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputLocation: [],
                locationOptions: [],
                headerExcelInfo: "",
                // locationPath: [],

                inputSortBy: 'parent_child',
                sortOptions: [
                    {key: 'parent_child', value: 'Parent-child Items'},
                    {key: 'id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'total_amount', value: 'Total Amount'},
                    {key: 'qty', value: 'Total Quantity'}
                ],
                inputFilterBy: 'none',
                filterOptions: [
                    {key: 'none', value: '-'},
                    {key: 'by_qty', value: 'Consolidate all quantity by line item'},
                ],
                currDate: moment().format("L_LT").split(":"),
                isSeparateSite: true,
                isShowDetail: true,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                birSalesReports: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,

                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: []
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == ''){
                    this.isShowDetail = true
                }
            },
            sortChange(e){
                if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                    this.inputShowTop = 0
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "order": this.inputSortBy,
                    "filter": this.inputFilterBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "top": this.inputShowTop,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'item_sales?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }
                var siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    // if(this.isShowDetail == true){
                    //     doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2'});
                    // }

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    if(this.isShowDetail == true){
                        headers = [
                            [
                                {content: '#', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Prod. Code', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Barcode', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Stock No.', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Description', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Retail Price', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Landed Cost', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Avg Cost', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Avg Price', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Gross Price', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Discount', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                            ]
                        ]
                    } else {
                        headers = [
                            [
                                '',
                                {content: 'Qty', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                            ]
                        ]
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let total_qty = 0
                        let total_total_amount = 0
                        let total_retail_price = 0
                        let total_landed_cost = 0
                        let total_avg_price = 0
                        let total_avg_cost = 0
                        let total_gross_price = 0
                        let grand_qty = 0
                        let grand_total_amount = 0
                        let grand_retail_price = 0
                        let grand_landed_cost = 0
                        let grand_avg_price = 0
                        let grand_avg_cost = 0
                        let grand_gross_price = 0

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        if(this.birSalesReports.length > 0){
                            let monthly_grouper_arr = []
                            let arr = 'start'

                            if(this.inputGroupBy == 'monthly' && this.isShowDetail == true){
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]

                                    if(i == this.birSalesReports.length-1){
                                        if(arr == 'start'){
                                            monthly_grouper_arr.push({
                                                key: reportLine.grouper_id,
                                                value: reportLine.grouper_name
                                            });
                                        } else {
                                            if(arr.key == reportLine.grouper_id){

                                                //replace value then push
                                                if(arr.value > reportLine.grouper_name){
                                                    arr.value = reportLine.grouper_name
                                                }

                                                monthly_grouper_arr.push(arr)
                                            } else {
                                                //push prev arr
                                                monthly_grouper_arr.push(arr)

                                                //push current arr
                                                monthly_grouper_arr.push({
                                                    key: reportLine.grouper_id,
                                                    value: reportLine.grouper_name
                                                });
                                            }
                                        }
                                    } else {
                                        if(arr == 'start'){
                                            arr = {
                                                key: reportLine.grouper_id,
                                                value: reportLine.grouper_name
                                            }
                                        } else {
                                            if(arr.key == reportLine.grouper_id){
                                                //replace value
                                                if(arr.value > reportLine.grouper_name){
                                                    arr.value = reportLine.grouper_name
                                                }

                                            } else {
                                                //push prev arr
                                                monthly_grouper_arr.push(arr)

                                                //replace current arr
                                                arr = {
                                                    key: reportLine.grouper_id,
                                                    value: reportLine.grouper_name
                                                };
                                            }
                                        }
                                    }
                                }
                            }

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let grouper_name = reportLine.grouper_name
                                if(this.inputGroupBy == 'daily'){
                                    grouper_name = moment(reportLine.grouper_name).format('YYYY/MM/DD')
                                } else if(this.inputGroupBy == 'monthly' && this.isShowDetail == true){
                                    let vdate = monthly_grouper_arr.find(x => x.key === reportLine.grouper_id).value
                                    grouper_name = moment(vdate).format('(YYYY) DD - MMMM')
                                } else if(this.inputGroupBy == 'monthly' && this.isShowDetail == false){
                                    grouper_name = moment(reportLine.grouper_name).format('(YYYY) DD - MMMM')
                                }

                                if(this.inputGroupBy == 'supplier_type_id'){
                                    if(type_header == 'start'){
                                        let type_header = [{content: reportLine.header_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}]
                                        reportData.push(Object.assign({}, type_header))
                                    } else {
                                        if(type_header != reportLine.header_id){
                                            let type_header = [{content: reportLine.header_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}]
                                            reportData.push(Object.assign({}, type_header))
                                        }
                                    }
                                    type_header = reportLine.header_id
                                }

                                if(this.inputGroupBy != ''){
                                    if(this.isShowDetail == true){
                                        if(grouper == 'start'){
                                            let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                            reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(grouper != reportLine.grouper_id){
                                                let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                                reportData.push(Object.assign({}, detail_header))
                                            }
                                        }
                                        grouper = reportLine.grouper_id
                                    }
                                }

                                let detail = []
                                if(this.isShowDetail == true){
                                    detail = [
                                        i+1,
                                        reportLine.product_code,
                                        reportLine.barcode,
                                        reportLine.stock_no,
                                        {content: reportLine.description, styles: {halign: 'left'}},
                                        this.convertToCurrency(Number(reportLine.retail_price)),
                                        this.convertToCurrency(Number(reportLine.qty)),
                                        this.convertToCurrency(Number(reportLine.landed_cost)),
                                        this.convertToCurrency(Number(reportLine.avg_cost)),
                                        this.convertToCurrency(Number(reportLine.avg_price)),
                                        // this.convertToCurrency(Number(reportLine.retail_price) * Number(reportLine.qty)),
                                        this.convertToCurrency(Number(reportLine.gross_price)),
                                        this.convertToCurrency(Number(reportLine.discount)),
                                        this.convertToCurrency(Number(reportLine.total_amount))
                                    ]
                                } else {
                                    detail = [
                                        grouper_name,
                                        this.convertToCurrency(Number(reportLine.qty)),
                                        this.convertToCurrency(Number(reportLine.total_amount))
                                    ]
                                }

                                reportData.push(Object.assign({}, detail))

                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)
                                total_retail_price += Number(reportLine.retail_price)
                                total_landed_cost += Number(reportLine.landed_cost)
                                total_avg_price += Number(reportLine.avg_price)
                                total_avg_cost += Number(reportLine.avg_cost)
                                // total_gross_price += (Number(reportLine.retail_price) * Number(reportLine.qty))
                                total_gross_price += Number(reportLine.gross_price)

                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)
                                grand_retail_price += Number(reportLine.retail_price)
                                grand_landed_cost += Number(reportLine.landed_cost)
                                grand_avg_price += Number(reportLine.avg_price)
                                grand_avg_cost += Number(reportLine.avg_cost)
                                // grand_gross_price += (Number(reportLine.retail_price) * Number(reportLine.qty))
                                grand_gross_price += Number(reportLine.gross_price)

                                if(i == this.birSalesReports.length-1){
                                    if(this.inputGroupBy != ''){
                                        let sub_detail = []
                                        if(this.isShowDetail == true){
                                            let spacer = grouper_name
                                            if(this.inputGroupBy == 'supplier_type_id'){
                                                spacer = reportLine.header_name
                                            }

                                            sub_detail = ["", "", "", "",
                                                {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                this.convertToCurrency(total_qty), '', '', '',this.convertToCurrency(total_gross_price) ,"",this.convertToCurrency(total_total_amount)]
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))
                                        }
                                    }

                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    if(this.isShowDetail == true){
                                        reportData.push(Object.assign({}, ['', '', '', '', 'Grand Total :', '',
                                            this.convertToCurrency(grand_qty), '', '', '',this.convertToCurrency(grand_gross_price), "" ,this.convertToCurrency(grand_total_amount)
                                        ]));

                                    } else {
                                        reportData.push(Object.assign({}, ['Grand Total :',
                                            this.convertToCurrency(grand_qty),
                                            this.convertToCurrency(grand_total_amount)
                                        ]));
                                    }
                                } else {
                                    if(this.isShowDetail == true){
                                        let current_grouper = ""
                                        let next_grouper = ""
                                        if(this.inputGroupBy == 'supplier_type_id'){
                                            current_grouper = reportLine.header_id
                                            next_grouper = this.birSalesReports[i+1].header_id
                                        } else {
                                            current_grouper = reportLine.grouper_id
                                            next_grouper = this.birSalesReports[i+1].grouper_id
                                        }

                                        if(current_grouper != next_grouper){
                                            if(this.inputGroupBy != ''){
                                                reportData.push(Object.assign({}, ["rowLine"]))
                                                let sub_detail = []

                                                let spacer = grouper_name
                                                if(this.inputGroupBy == 'supplier_type_id'){
                                                    spacer = reportLine.header_name
                                                }

                                                if(this.isShowDetail == true){
                                                    sub_detail = ["", "", "", "",
                                                        {content: spacer, styles: {halign: 'right', fontStyle: 'bold'}}, "",
                                                        this.convertToCurrency(total_qty), '', '', '', this.convertToCurrency(total_gross_price),"",this.convertToCurrency(total_total_amount)]
                                                } else {
                                                    sub_detail = [{content: spacer, styles: {halign: 'right', fontStyle: 'bold'}},
                                                        this.convertToCurrency(total_qty),
                                                        this.convertToCurrency(total_total_amount)
                                                    ]
                                                }
                                                reportData.push(Object.assign({}, sub_detail))

                                                total_qty = 0
                                                total_total_amount = 0
                                                total_retail_price = 0
                                                total_landed_cost = 0
                                                total_avg_price = 0
                                                total_avg_cost = 0
                                                total_gross_price = 0
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        let design_x = 525
                        let design_y = 225
                        
                        if(this.isShowDetail == true){
                            design_x = 600
                            design_y = 400
                        }
                        
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Item Sales Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(design_x,20,siteSpecific[x].report_details[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(design_x,20,site_text,"right");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let splitTitle = doc.splitTextToSize("Filtered by: " + status_header + filter_header, 180);
                        doc.text(15,30,splitTitle);

                        let colStyles = {}

                        if(this.isShowDetail == true){
                            colStyles = {
                                0: {cellWidth: 10},
                                1: {cellWidth: 30},
                                2: {cellWidth: 27},
                                3: {cellWidth: 22},
                                4: {cellWidth: 50},
                                5: {cellWidth: 25},
                                6: {cellWidth: 21},
                                7: {cellWidth: 25},
                                8: {cellWidth: 22},
                                9: {cellWidth: 22},
                                10: {cellWidth: 25},
                                11: {cellWidth: 22},
                                12: {cellWidth: 30},
                            }
                        } else {
                            colStyles = {
                                0: {cellWidth: 205},
                                1: {cellWidth: 60},
                                2: {cellWidth: 60}
                            }
                        }

                        doc.autoTable({
                            startY: 45,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right',
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                       
                    }
                    let group_text = ''
                    if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }
                   let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let footer_x = 340
                    let footer_y =  205
                    let pageCount = doc.internal.getNumberOfPages();

                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Item Sales Report" + group_text, footer_x, footer_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Item_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            getBase64Image(url) {
                const img = new Image();
                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const dataURL = canvas.toDataURL("image/png");
                    console.log(dataURL)
                }
                return img.src = url
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Item Sales Report", {
                    pageSetup:{paperSize: 9}
                });

                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                const data_starts_at_row = 8

                let reportLogo = document.getElementById('reportLogo');
            
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)

                const imageId2 = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });

                sheet.addImage(imageId2, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });

                sheet.getRow(4).values = ["Item Sales Report"]
                sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                sheet.getRow(6).values = [`Filtered by: ${status_header}${filter_header}}`]

                //custom header
                sheet.getRow(data_starts_at_row).values = ["#", "Product Code", 
                    "Barcode", "Stock No", "Description",
                    "Retail Price", "Quantity", "Landed Cost", "Average Cost", "Average Price", "Gross Price", "Discount" ,"Total Amount"];

                sheet.columns = [
                    { key: "#" , width: 20 },
                    { key: "product_code", width: 15 },
                    { key: "barcode" , width: 20 },
                    { key: "stock_no", width: 15 },
                    { key: "desc", width: 30 },
                    { key: "retail_price", width: 15 },
                    { key: "qty", width: 15 },
                    { key: "landed_cost", width: 15 },
                    { key: "avg_cost", width: 15 },
                    { key: "avg_price", width: 15 },
                    { key: "gross_price", width: 15 },
                    { key: "discount", width: 15 },
                    { key: "total_amount" , width: 15 },
                ];

                var report_details = this.JsonData
                // var report_details = get_request[0].report_details
                console.log("details", report_details)
                console.log(this.JsonData)
                var rowDatas = []
                var horizontal_range = 0
                for(let i = 0; i < report_details.length; i++){
                    const report_detail = report_details[i]
                        if(report_detail){
                            const rowData = {"#": report_detail["#"], desc: report_detail["Name or Description"], barcode: report_detail["Barcode"], 
                            product_code: report_detail["Product Code"], landed_cost: report_detail["Landed Cost"], qty: report_detail["Quantity"], 
                            avg_price: report_detail["Average Price"] ,avg_cost: report_detail["Average Cost"], retail_price: report_detail["Retail Price"], stock_no: report_detail["Stock No"], gross_price: report_detail["Gross Price"], 
                            total_amount: report_detail["Total Amount"], discount: report_detail["Discount"]}
                            rowDatas.push(rowData)
                        }
                    }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                // sheet.getRow(7).font = { bold: true };
                sheet.getRow(data_starts_at_row).font = { bold: true };

                // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                // })

                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            }
                            else{
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })
                
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `itemSalesReport.xlsx`);
                });
                this.JsonData = []
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "group": this.inputGroupBy,
                    "isShow": this.isShowDetail,
                    "order": this.inputSortBy,
                    "filter": this.inputFilterBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "top": this.inputShowTop,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'item_sales?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }
                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ["#", "Product Code", "Barcode", "Stock No", "Name or Description", "Retail Price", "Landed Cost", "Average Cost", "Average Price", "Quantity", "Gross Price", "Discount", "Total Amount"];
                    let site_specific = [];

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let total_qty = 0
                            let total_total_amount = 0
                            let total_retail_price = 0
                            let total_landed_cost = 0
                            let total_average_price = 0
                            let total_gross_price = 0

                            let grand_qty = 0
                            let grand_total_amount = 0
                            let grand_retail_price = 0
                            let grand_landed_cost = 0
                            let grand_average_price = 0
                            let grand_gross_price = 0

                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let detail = []
                                detail = [
                                    i+1,
                                    reportLine.product_code,
                                    reportLine.barcode,
                                    String(reportLine.stock_no),
                                    reportLine.description,
                                    reportLine.retail_price,
                                    reportLine.landed_cost,
                                    this.convertToCurrency(Number(reportLine.avg_cost,)),
                                    this.convertToCurrency(Number(reportLine.avg_price,)),
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    // this.convertToCurrency(Number(reportLine.retail_price) * Number(reportLine.qty)),
                                    this.convertToCurrency(Number(reportLine.gross_price)),
                                    reportLine.discount,
                                    this.convertToCurrency(Number(reportLine.total_amount))
                                ]
                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)
                                total_retail_price += Number(reportLine.retail_price)
                                total_landed_cost += Number(reportLine.landed_cost)
                                total_average_price += Number(reportLine.avg_price)
                                // total_gross_price += Number(reportLine.retail_price) * Number(reportLine.qty)
                                total_gross_price += Number(reportLine.gross_price)

                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)
                                grand_retail_price += Number(reportLine.retail_price)
                                grand_landed_cost += Number(reportLine.landed_cost)
                                grand_average_price += Number(reportLine.avg_price)
                                // grand_gross_price += Number(reportLine.retail_price) * Number(reportLine.qty)
                                grand_gross_price += Number(reportLine.gross_price)

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    sub_detail = ['','','','','Sub Total :', '', '',
                                            '', '', this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_gross_price),
                                            "",
                                            this.convertToCurrency(total_total_amount)
                                        ]
                                    reportData.push(Object.assign({}, sub_detail))

                                    //Grand Total
                                    let grand_detail =['','','','','Grand Total :', '', '',
                                            '', '',this.convertToCurrency(grand_qty),
                                            this.convertToCurrency(grand_gross_price),
                                            "",
                                            this.convertToCurrency(grand_total_amount)
                                    ]
                                    reportData.push(Object.assign({}, grand_detail));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        sub_detail = ['','','','','Sub Total :', '', '',
                                            '', '', this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_gross_price),
                                            "",
                                            this.convertToCurrency(total_total_amount)
                                        ]

                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_total_amount = 0
                                        total_retail_price = 0
                                        total_landed_cost = 0
                                        total_average_price = 0
                                        total_gross_price = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        if(this.isSeparateSite == true){
                            reportData.unshift([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push([])
                        reportData.push(["Item Sales Report" + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false;
            },
            clearJsonData(){
             this.JsonData = [];
            },
        }
    };
</script>

<style></style>
